// src/data/playerStats.js
export const playerStats = {
    "Lionel Messi": [
      { year: 2023, goals: 20, assists: 16 }, // MVP season :contentReference[oaicite:2]{index=2}
      { year: 2024, goals: 12, assists: 7 }   // ongoing trends :contentReference[oaicite:3]{index=3}
    ],
    "Carlos Vela": [
      { year: 2020, goals: 10, assists: 7 },
      { year: 2021, goals: 15, assists: 10 },
      { year: 2022, goals: 8, assists: 6 },
      { year: 2023, goals: 9, assists: 5 },
      { year: 2024, goals: 7, assists: 4 }
    ],
    "Sebastian Giovinco": [
      { year: 2020, goals: 0, assists: 0 },
      { year: 2021, goals: 0, assists: 0 },
      { year: 2022, goals: 0, assists: 0 },
      { year: 2023, goals: 0, assists: 0 },
      { year: 2024, goals: 0, assists: 0 }
    ], // retired
    "Kei Kamara": [
      { year: 2020, goals: 5, assists: 2 },
      { year: 2021, goals: 6, assists: 3 },
      { year: 2022, goals: 4, assists: 1 },
      { year: 2023, goals: 3, assists: 2 },
      { year: 2024, goals: 2, assists: 1 }
    ],
    "Diego Valeri": [
      { year: 2020, goals: 2, assists: 1 },
      { year: 2021, goals: 3, assists: 2 },
      { year: 2022, goals: 2, assists: 2 },
      { year: 2023, goals: 1, assists: 1 },
      { year: 2024, goals: 0, assists: 0 }
    ],
    "Jozy Altidore": [
      { year: 2020, goals: 4, assists: 3 },
      { year: 2021, goals: 5, assists: 2 },
      { year: 2022, goals: 3, assists: 1 },
      { year: 2023, goals: 2, assists: 1 },
      { year: 2024, goals: 1, assists: 0 }
    ],
    "Hany Mukhtar": [
      { year: 2020, goals: 14, assists: 6 },
      { year: 2021, goals: 16, assists: 10 },
      { year: 2022, goals: 8, assists: 5 },
      { year: 2023, goals: 10, assists: 8 },
      { year: 2024, goals: 9, assists: 7 }
    ]
  };
  